function validPoint(point) {
  return Number.isFinite(point?.lat) && Number.isFinite(point?.lng);
}

function validGeometry(geometry) {
  return Array.isArray(geometry) && geometry.length > 1
    && geometry.every((coordinate) => Array.isArray(coordinate) && Number.isFinite(coordinate[0]) && Number.isFinite(coordinate[1]));
}

export function routeForMap({ origin, destination, station, tripMode, baseRoadRoute, inspectedRoadRoute }) {
  const roadGeometry = inspectedRoadRoute?.geometry || (tripMode === "enRoute" ? baseRoadRoute?.geometry : null);
  if (validGeometry(roadGeometry)) return { geometry: roadGeometry, estimated: false };

  const target = tripMode === "enRoute" ? destination : station;
  if (validPoint(origin) && validPoint(target)) {
    return { geometry: [[origin.lng, origin.lat], [target.lng, target.lat]], estimated: true };
  }
  return { geometry: null, estimated: false };
}
